import React, { useState } from 'react';
import { XIcon, ChatIcon as AiChatIcon } from '@stashinvest/react-assets';
import { ButtonIcon, FullSheet, Toolbar } from '@stashinvest/react-components';
import Chat from './Chat';
import { useBanjo } from '@stashinvest/react-banjo';
import {
	v1_AiChatEntryPoint_Clicked,
	v1_AiChat_Closed,
} from '@stashinvest/product-events-javascript/lib/v1/event_static_methods';
import { ChatAnalytics } from './types';
import { useTrack } from 'stash/hooks/useTrack';

type ChatIconProps = {
	analytics: ChatAnalytics;
	className?: string;
	focus?: string;
	initMessage?: string | null;
};

export const ChatIcon = ({ analytics, className, focus, initMessage }: ChatIconProps) => {
	const { getString } = useBanjo();
	const [showAiChat, setShowAiChat] = useState(false);
	const track = useTrack();

	const toggleAiChat = () => {
		if (!showAiChat) {
			track(
				v1_AiChatEntryPoint_Clicked({
					...analytics,
					focus: analytics.focus || focus,
				})
			);
		} else {
			track(v1_AiChat_Closed({ ...analytics }));
		}
		setShowAiChat((prevState) => !prevState);
	};

	return (
		<>
			<ButtonIcon
				className={`bg-primary !w-[42px] !h-[42px] gridMedium:!w-[52px] gridMedium:!h-[52px] ${
					className || ''
				}`}
				onClick={toggleAiChat}
				Icon={() => <AiChatIcon size={'small'} color="text-onPrimary" />}
			/>
			{showAiChat && (
				<FullSheet
					data-testid="ai-chat-banner"
					className="bg-onPrimary"
					onClose={toggleAiChat}
					navLayout={({ closeSheet }) => (
						<Toolbar
							header="AI Money Coach (beta)"
							variant={{
								navButtonIcon: {
									Icon: () => <XIcon size="XS" />,
									altText: getString('altText/buttonIcon/backToPrevious'),
									onClick: closeSheet,
								},
								type: 'page',
							}}
						/>
					)}
					mainLayout={
						<Chat
							analytics={analytics}
							initMessage={initMessage}
							focus={focus}
							track={track}
						/>
					}
				/>
			)}
		</>
	);
};
